'use client';

import PencilSvg from '@/assets/svgs/pencil.svg';
import TrashSvg from '@/assets/svgs/trash-can.svg';
import { inter600 } from '@/config/fonts';
import { showNumberOfItemsInColumnMapping } from '@/shared/utils/contact-list';
import classNames from 'classnames';
import IconButton from '../../../shared/components/Buttons/IconButton/IconButton';
import { ColumnFieldMappingdData } from '../types';

interface ManageFieldMappingProps {
  fieldMappingData: ColumnFieldMappingdData;
  className?: string;
  onDelete: (name: string) => void;
  onEdit: () => void;
}

const ManageFieldMapping = ({
  fieldMappingData,
  className,
  onDelete,
  onEdit,
}: ManageFieldMappingProps) => {
  const { columnNumber, data, title, name, icon } = fieldMappingData;

  return (
    <div
      className={classNames(
        'group bg-base-100 dark:bg-base-200 relative flex h-[289px] w-60 flex-col overflow-hidden rounded-xl border-[1px] border-gray-200 dark:border-gray-700',
        className
      )}>
      <div
        className={classNames(
          'column-header m-1 flex h-8 min-h-8 items-center justify-between gap-2 px-2 text-sm text-gray-500 dark:text-gray-400',
          inter600.className
        )}>
        <span className="text-gray-500 dark:text-gray-400">{icon}</span>
        <span>{title}</span>
        <span className="flex-1" />
        <IconButton
          title="Delete mapping"
          className="hover:text-error btn-ghost btn-sm"
          onClick={() => {
            onDelete(name);
          }}
          icon={<TrashSvg className="h-5 w-5" />}
        />
      </div>
      <div className="items flex flex-col gap-2 overflow-auto px-2">
        <div
          className={classNames(
            'bg-base-100 dark:bg-base-200 text-primary flex w-full items-center justify-between rounded-lg border border-gray-200 py-1.5 pr-3 pl-3 text-sm shadow-sm dark:border-gray-700 dark:text-gray-400',
            inter600.className
          )}>
          Col {columnNumber}
          <IconButton
            className="btn-ghost btn-xs text-gray-500"
            title="Edit field mapping"
            icon={<PencilSvg className="h-4 w-4" />}
            onClick={() => onEdit()}
          />
        </div>

        <div className="items py-1">
          {data?.slice(0, showNumberOfItemsInColumnMapping).map((item, idx) => {
            return (
              <div key={idx} className="flex h-8 items-center gap-[21px] pl-3 text-sm">
                <span className="text-gray-default dark:text-gray-400">{idx + 1}</span>
                <span
                  title={item}
                  className="text-black-default overflow-hidden text-ellipsis whitespace-nowrap dark:text-gray-200">
                  {item}
                </span>
              </div>
            );
          })}
          {data.length > showNumberOfItemsInColumnMapping && (
            <div className="flex h-8 items-center gap-[21px] pl-3 text-sm">
              +{data.length - showNumberOfItemsInColumnMapping} more
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageFieldMapping;
